import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import CrispMerchantMobileFilter from '../../filters/CrispMerchantMobileFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var SoundBoxTransactionTable='';


class SoundBoxTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchant_mobile:'',
            loading:false,
            model_visible : false,
            isChange: false,
            fetch_data:false,
         
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "sound_box_txn_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }
        if(decoded.object_type==='Acquiring Bank'){
            this.setState({
                acqBankIds: arrayCode
            })
        }
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {
     }
    componentDidMount() {
        this.get_filtered_sound_box_report(this.state.object_type,this.state.object_code,'');
    }

    get_filtered_sound_box_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var acquirer = this.state.acqBankIds;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        if(object_type==='Acquiring Bank' && this.state.acqBankIds===''){
            acquirer = object_code;
        }

        var postData = {
            merchant_mobile: this.state.merchant_mobile,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"sound_box_txn_report"
        };
        if ($.fn.DataTable.isDataTable('#SoundBoxTransactionTable')) {
            $('#SoundBoxTransactionTable').DataTable().clear().destroy();
        }
        var SoundBoxTransactionTable = $('#SoundBoxTransactionTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/soundbox-txn-report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    { "data": "Merchant ID" },
                    { "data": "Merchant Mobile" },
                    { "data": "Trade Name" },
                    { "data": "Payment ID" },
                    { "data": "QR ID" },
                    { "data": "Amount Settled" },
                    { "data": "Settlement Status" },
                    { "data": "Customer VPA" },
                    { "data": "Customer Name" },
                    { "data": "UPI Payment ID" },
                    { "data": "Acquirer ID" },
                    { "data": "Acquirer Name" },
                    { "data": "RRN" },
                    { "data": "Acquirer Payment ID" },
                    { "data": "UTR Number" },
                    { "data": "Settled From Bank" },
                    { "data": "Is Settled" },
                    { "data": "Transaction Date" },
                    { "data": "Transaction Time" },
                    { "data": "Settlement Date" },
                    { "data": "Settlement Time" },
                    { "data": "Settlement ID" },
                ],

                "columnDefs": [
//                     {  render: function (data) {
//                             return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
//                         },
//                         "width": "80px",
//                         "targets": 12
//                     },
//                     {  render: function (data) {
//                             return "<div class='text-wrap width-80'>" +moment(data).format('D MMM YYYY')+ "</div>";
//                         },
//                         "width": "80px",
//                         "targets": 7
//                     },
//                     {
//                         render: function (data, type, full, meta) {
//                             if(data===null || data===''|| data ==='null'){
//                             data = '';
//                             }
//                             return "<div class='text-wrap width-150'>" + data + "</div>";
//                         },
//                         "targets": [0,1,2]
//                     },

                ],

            });

    }

    SoundBoxTransactionDownloadCheck(object_type, object_code, event){
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var acquirer = this.state.acqBankIds;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        if(object_type==='Acquiring Bank' && this.state.acqBankIds===''){
            acquirer = object_code;
        }
        let filters = {
            merchant_mobile: this.state.merchant_mobile,
            acq_bank_code: acquirer,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            report_code:"sound_box_txn_report",
            download: 1,
            user_id: this.state.user_id

        }
        this.setState({
            filters:filters
        })
        if(this.state.merchant_mobile===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/soundbox-txn-report','sound_box_txn_report', 60);
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/soundbox-txn-report','sound_box_txn_report', 60);
        }
    }
   
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
          //  this.refs.merchantFilter.restMerchantFilter();
//             this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
//             this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
//             this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
//             this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
//             this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
//             this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
//             this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
         this.refs.CrispMerchantMobileFilter.fetchMobiles();

        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchant_mobile:'',
            isChange: false
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });


    }
    handleCrispMerchantMobileFilter= (optionSelected, event_names) =>
    {
        this.setState({
            merchant_mobile:event_names,
            isChange: true
        });
    }
    render() {
        return(
        
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Sound Box Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Merchant Mobile </label>
                                            <CrispMerchantMobileFilter ref="CrispMerchantMobileFilter" onSelectCrispMerchantMobile = {this.handleCrispMerchantMobileFilter} />
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_sound_box_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.SoundBoxTransactionDownloadCheck.bind(this, this.state.object_type,this.state.object_code)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="SoundBoxTransactionTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                <th>Merchant ID</th>
                                                <th>Merchant Mobile</th>
                                                <th>Trade Name</th>
                                                <th>Payment ID</th>
                                                <th>QR ID</th>
                                                <th>Amount Settled</th>
                                                <th>Settlement Status</th>
                                                <th>Customer VPA</th>
                                                <th>Customer Name</th>
                                                <th>UPI Payment ID</th>
                                                <th>Acquirer ID</th>
                                                <th>Acquirer Name</th>
                                                <th>RRN</th>
                                                <th>Acquirer Payment ID</th>
                                                <th>UTR Number</th>
                                                <th>Settled From Bank</th>
                                                <th>Is Settled</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Settlement Date</th>
                                                <th>Settlement Time</th>
                                                <th>Settlement ID</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( SoundBoxTransactionReport );